module.exports = __webpack_public_path__ + "img/asus-ux581.e8480956.jpg";